export default __webpack_public_path__ + "static/media/CV_Ahmad Wahyu Awaludin.49c35820.pdf";